export interface FontStyle {
  fontFamily: string;
  lineHeight?: string;
  size?: string;
  style?: 'normal' | 'italic' | 'oblique';
  variant?: 'normal' | 'small-caps';
  weight?: 'normal' | 'bold' | '100' | '200' | '300' | '400' | '500' | '600' | '700' | '800' | '900';
}

export const DEFAULT_FONT_FAMILY = 'Roboto';

/**
 * Generate font attributes string from font attributes object
 * see https://www.w3.org/TR/CSS21/fonts.html#font-shorthand
 * The order of the parts must follow: style, variant, weight, size/line-height, font-family
 */
export function generateFontAttributes({ style, variant, weight, size, lineHeight, fontFamily }: FontStyle): string {
  const parts = [style, variant, weight, `${size || ''}${lineHeight ? '/' + lineHeight : ''}`, fontFamily];
  return parts.filter(Boolean).join(' ');
}
